import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { byName, toCbBranch } from '../../../branches/data/datasources/branch-shape';

/**
 * `GET /client/:cid/hubs` has no `branches[]` per hub, so the branch list is joined on `hub_id` (the home map lists a
 * hub's branches).
 */
export const getHubs = async (): Promise<any[]> => {
  const [hubs, branches] = await Promise.all([
    lpRequest('GET', clientPath('/hubs')),
    lpRequest('GET', clientPath('/branch'))
  ]);
  const cbBranches = (branches || []).map((branch: any) => toCbBranch(branch)).sort(byName);

  return (hubs || [])
    .map((hub: any) => ({
      ...hub,
      branches: cbBranches.filter((branch: any) => branch.hub_id === hub.id)
    }))
    .sort(byName);
};
